/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ExamQuestionLibraryItemId202,
  PutApiV1ExamQuestionLibraryItemId400,
  PutApiV1ExamQuestionLibraryItemId401,
  PutApiV1ExamQuestionLibraryItemId404,
  PutApiV1ExamQuestionLibraryItemId500,
  PutApiV1ExamQuestionLibraryItemIdMutationRequest,
  PutApiV1ExamQuestionLibraryItemIdMutationResponse,
  PutApiV1ExamQuestionLibraryItemIdPathParams,
} from "../../types/examQuestionLibraryController/PutApiV1ExamQuestionLibraryItemId.ts";
import { examItemEditorViewModelSchema } from "../examItemEditorViewModelSchema.ts";

export const putApiV1ExamQuestionLibraryItemIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ExamQuestionLibraryItemIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ExamQuestionLibraryItemId202Schema =
  z.any() as unknown as ToZod<PutApiV1ExamQuestionLibraryItemId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ExamQuestionLibraryItemId400Schema =
  z.any() as unknown as ToZod<PutApiV1ExamQuestionLibraryItemId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ExamQuestionLibraryItemId401Schema =
  z.any() as unknown as ToZod<PutApiV1ExamQuestionLibraryItemId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ExamQuestionLibraryItemId404Schema =
  z.any() as unknown as ToZod<PutApiV1ExamQuestionLibraryItemId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ExamQuestionLibraryItemId500Schema =
  z.any() as unknown as ToZod<PutApiV1ExamQuestionLibraryItemId500>;

export const putApiV1ExamQuestionLibraryItemIdMutationRequestSchema = z.lazy(
  () => examItemEditorViewModelSchema,
) as unknown as ToZod<PutApiV1ExamQuestionLibraryItemIdMutationRequest>;

export const putApiV1ExamQuestionLibraryItemIdMutationResponseSchema = z.lazy(
  () => putApiV1ExamQuestionLibraryItemId202Schema,
) as unknown as ToZod<PutApiV1ExamQuestionLibraryItemIdMutationResponse>;
